//?import statements
import { useState } from "react";
import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
//? styles
import styles from "./reviews.module.css";

import Review from "./review";
const Reviews = (props) => {
  const { data } = props;

  const [reviewNumber, setReviewNumber] =
    useState(0);
  const lengthOfData = data.length;
  const nextPerson = () => {
    if (reviewNumber < lengthOfData - 1) {
      setReviewNumber((prevData) => {
        return prevData + 1;
      });
    }
  };
  const previousPerson = () => {
    if (reviewNumber !== 0) {
      setReviewNumber((prevData) => {
        return prevData - 1;
      });
    }
  };

  const supriseMeHandler = () => {
    const randomNumber = Math.floor(
      Math.random() * lengthOfData
    );

    setReviewNumber(randomNumber);
  };
  return (
    <section
      className={styles["reviews-container"]}
    >
      <Review {...data[reviewNumber]} />
      <div className={styles["button-container"]}>
        {reviewNumber !== 0 && (
          <button onClick={previousPerson}>
            <FaChevronLeft
              className={styles["icons"]}
            />
          </button>
        )}
        {reviewNumber === 0 && (
          <button
            onClick={previousPerson}
            disabled={true}
          >
            <FaChevronLeft
              className={styles["icons"]}
            />
          </button>
        )}
        {reviewNumber < lengthOfData - 1 ? (
          <button onClick={nextPerson}>
            <FaChevronRight
              className={styles["icons"]}
            />
          </button>
        ) : (
          <button disabled={true}>
            <FaChevronRight
              className={styles["icons"]}
            />
          </button>
        )}
      </div>
      <button
        type="button"
        className={styles["button"]}
        onClick={supriseMeHandler}
      >
        Surprise Me
      </button>
    </section>
  );
};

export default Reviews;
